import React from "react";
import PropTypes from "prop-types";

import { entitySubtitle } from "../../utils/entityDisplay";
import { companyUrl } from "../../utils/urls";

// Renders entitySubtitle's string with the company as a link to its page. The link is only
// safe when the helper actually ended with the company: on titles that already name it the
// helper folds the company in, and there is no standalone occurrence to wrap. Callers own the
// wrapper element (and its truncation), so a clipped line hides the link exactly as it hides
// the rest of the text — no second ellipsis.
function EntitySubtitle({ entity, linkClassName = "entity-company-link" }) {
  const subtitle = entitySubtitle(entity);
  const company = entity.company_name || "";
  const href =
    company && (entity.company_slug || entity.company_migrate_id)
      ? companyUrl({ slug: entity.company_slug, migrate_id: entity.company_migrate_id })
      : null;

  if (!href || !subtitle.endsWith(company)) {
    return subtitle;
  }

  return (
    <>
      {subtitle.slice(0, subtitle.length - company.length)}
      <a href={href} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        {company}
      </a>
    </>
  );
}

EntitySubtitle.propTypes = {
  entity: PropTypes.shape({
    title: PropTypes.string,
    company_name: PropTypes.string,
    company_slug: PropTypes.string,
    company_migrate_id: PropTypes.string,
  }).isRequired,
  linkClassName: PropTypes.string,
};

export default EntitySubtitle;
